import type { ReactNode } from "react"

export type AlertTone = "error" | "success" | "info" | "warning"

const TONE_CLASSES: Record<AlertTone, { wrap: string; icon: string }> = {
  error: {
    wrap: "bg-red-50 border border-red-200 text-red-700",
    icon: "ri-error-warning-line text-red-500",
  },
  success: {
    wrap: "bg-emerald-50 border border-emerald-200 text-emerald-700",
    icon: "ri-checkbox-circle-line text-emerald-500",
  },
  info: {
    wrap: "bg-blue-50 border border-blue-200 text-blue-700",
    icon: "ri-information-line text-blue-500",
  },
  warning: {
    wrap: "bg-amber-50 border border-amber-200 text-amber-700",
    icon: "ri-alert-line text-amber-500",
  },
}

export type AlertProps = {
  tone?: AlertTone
  children: ReactNode
  className?: string
  /** Скрыть иконку (если фон без иконки). */
  hideIcon?: boolean
}

export const Alert = ({ tone = "error", children, className = "", hideIcon = false }: AlertProps) => {
  const cls = TONE_CLASSES[tone]
  return (
    <div
      role={tone === "error" || tone === "warning" ? "alert" : "status"}
      className={`flex items-start gap-2 rounded-xl px-4 py-3 text-sm ${cls.wrap} ${className}`}
    >
      {hideIcon ? null : <i className={`${cls.icon} text-base leading-5 mt-0.5`} aria-hidden />}
      <div className="min-w-0 flex-1">{children}</div>
    </div>
  )
}
